//////////////////////////////////////////////////////////
//                                                      //   
//  PARA TODOS OS USUÁRIOS:                             //   
//                                                      //   
//  APARECE COMO CARD PARA PREENCHIMENTO DE             //   
//  INFORMAÇÕES PESSOAIS NA PÁGINA DE LOGIN             //   
//                                                      //   
//  FUNCIONALIDADE: CRIAR CADASTRO PARA NOVO USUÁRIO    //    
//                                                      //   
//////////////////////////////////////////////////////////    



//////////////////////////////////////////////////////////////////////////
//                                                                      //
//  LISTA DE PÁGINAS E OUTROS COMPONENTES QUE UTILIZAM ESSE ARQUIVO:    //
//                                                                      //
//      frontend/src/pages/login.js                                     //
//                                                                      //
//////////////////////////////////////////////////////////////////////////



import React from "react"

import MaskedInput from 'react-text-mask'

import api from "../services/api";


function FormCriarUsuario() {

    async function teste_submit(){  // FUNÇÃO PARA VERIFICAR SE O SUBMIT DAS INFORMAÇÕES PODE SER FEITO
        // FUNÇÃO CHAMADA NO CLICK DO BOTÃO 'Criar Cadastro' DESTE COMPONENTE

        for (var i = 3; i < document.getElementsByTagName('input').length; i++){  // PARA TODOS OS ITENS DE TEXTO
            document.getElementsByTagName('input')[i].classList.remove('border-erro')  // REMOVE ERROS ANTERIORES
        }

        var dict_dados = {'acao': 'criar'}  // CRIA O DICIONÁRIO PARA ENVIAR OS DADOS PARA O DB

        var submit = true
        for (i = 3; i < document.getElementsByTagName('input').length; i++){  // PARA CADA ITEM DE TEXTO
            var item  = document.getElementsByTagName('input')[i] 
            if(item.value !== ''){  // VERIFICA SE O VALOR NÃO ESTÁ VAZIO
                if(item.placeholder === ''){  // SE NÃO EXISTIR PLACE HOLDER (POIS ITENS COM PLACE HOLDER TEM O VALOR DA MÁSCARA)
                    dict_dados[item.id] = item.value // ADICIONA NO DICIONÁRIO DAS INFORMAÇÕES               
                }
                else{  // SE EXISTIR PLACEHOLDER
                    if(item.value.includes('_')){  // VERIFICA SE NENHUM CARACTÉR DO PLACEHOLDER AINDA ESTÁ VAZIO
                        submit = false  // CASO ESTIVER VAZIO, NÃO SUBMETE
                        item.classList.add('border-erro')  // E APONTA ERRO                        
                    }
                    else{ // SE ESTIVER TUDO COMPLETO
                        dict_dados[item.id] = item.value // ADICIONA NO DICIONÁRIO DAS INFORMAÇÕES
                    }
                }
            }
            else{  // SE O CAMPO ESTIVER VAZIO
                submit = false  // NÃO SUBMETE
                item.classList.add('border-erro')  // E APONTA ERRO
            }
        }   
        if (document.getElementById('senha_confirmar').value !== document.getElementById('senha').value){  // SE OS CAMPOS DE SENHA E CONFIRMAÇÃO DE SENHA FOREM DIFERENTES
            submit = false  // TAMBÉM NÃO SUBMETE
            document.getElementById('senha_confirmar').classList.add('border-erro')  // E APONTA ERRO
        }
        
        if (submit){  // CASO O SUBMIT SEJA POSSÍVEL
            var criar = await api.post('usuario',{  // CRIA NO DB OS DADOS DE USUÁRIO
                dict_dados
              }).then((response) => {
                return response
              })
            // criar['data'] RETORNA UM DICIONÁRIO COM AS CHAVES
              // 'criado' -> BOOLEANO QUE INDICA SE O CADASTRO FOI REALIZADO

              // 'data' -> STRING
                // CASO 'criado' SEJA FALSO, RETORNA UMA MENSAGEM DO PORQUE (USUÁRIO JÁ EXISTE, ETC) 
                // CASO 'criado' SEJA TRUE, RETORNA O TOKEN DO USUÁRIO CADASTRADO PARA LOGIN
                
            if (!criar.data.criado){  // CASO NÃO FOI POSSÍVEL CRIAR O CADASTRO
                document.getElementById('msg').innerText = criar.data.data  // INDICAO AO USUÁRIO O PORQUE
            }
            else{  // CASO O CADASTRO TENHA SIDO REALIZADO
                sessionStorage.setItem('login', criar.data.data)  // ADICIONA O TOKEN DO USUÁRIO NA SESSÃO (UM TOKEN NA SESSÃO INDICA QUE O USUÁRIO ESTÁ LOGADO)
                add_session_db()  // ADICIONA NO DB AS INFORMAÇÕES DOS PRODUTOS NO CARRINHO
                
                var id_loja = sessionStorage['loja']  // REDIRECIONA PARA A PÁGINA HOME
                window.location.href = '/?id='+ id_loja
            }
        }
    }

    async function add_session_db(){  // FUNÇÃO PARA ADICIONAR OS PRODUTOS QUE ESTÃO NO CARRINHO (SALVOS NA SESSAO) NO DB
        // FUNÇÃO CHAMADA APÓS O SUCESSO DO LOGIN NA FUNÇÃO 'teste_submit' NESSE COMPONENTE

        var dict_itens = {'usuario': sessionStorage['login'], 'loja': sessionStorage['loja']}  // CRIA O DICIONÁRIO PARA ADICIONAR OS PRODUTOS NO DB
        if (sessionStorage['favoritar']){  // FAVORITAR ESTÁ SEMPRE VAZIO POIS FOI RETIRADO A PEDIDO DO DEPARTAMENTO DE MARKETING
            dict_itens['favoritar'] = sessionStorage['favoritar']
        }
        if (sessionStorage['comprar']){  // PEGA OS PRODUTOS NO CARRINHO DA SESSAO
            var itens = sessionStorage['comprar'].split(';') 

            for(var i = 0; i < itens.length; i++){  // PARA CADA ITEM
                var dict = JSON.parse(itens[i])  // PEGA AS INFORMAÇÕES NO FORMATO CORRETO
                dict_itens['comprar'] = dict['id']
                dict_itens['quantidade'] = dict[dict['id']]['carrinho']


                var produtos = await api.post('add_session_db',{  // E SALVA NO DB
                    dict_itens
                  }).then((response) => {
                    return response
                  })
                // 'produtos' NÃO RETORNA NADA
        
            }
        }      
    }

    // OS COMPONENTES DA PÁGINA SÃO (NA ORDEM QUE APARECEM):
        // 'MaskedInput' -> COMPONENTE NATIVO DO REACT PARA REALIZAR A MASCARA DE CPF E TELEFONE

    return(   
        <div>
            <p class="preco verde montserrat mt-3 mb-0 pb-2 font-x-larger px-5 border-bottom">Informações Pessoais</p>

            <div class="border-bottom-black p-4">
                <div class='col col-12 row px-0 mx-0 mb-3'>
                    <div class="col-4 p-0 mx-0">
                        <h5 class='montserrat verde'>Nome Completo</h5>
                        <input id='nome' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                    </div>

                    <div class="col-4 px-3 py-0 mx-0">
                        <h5 class='montserrat verde'>CPF</h5>
                        <MaskedInput
                            mask={[/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/]}
                            className="w-100 no-outline busca border-redonda tamanho-filtro px-2"
                            placeholder="xxx.xxx.xxx-xx"
                            id="cpf"
                        />                      
                    </div>

                    <div class="col-4 p-0 mx-0">
                        <h5 class='montserrat verde'>Telefone Celular</h5>
                        <MaskedInput
                            mask={['(', /[1-9]/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]}
                            className="w-100 no-outline busca border-redonda tamanho-filtro px-2"
                            placeholder="(xx) xxxxx-xxxx"
                            id="telefone"
                        />                    
                    </div>
                </div>
            
                <div class='col col-12 row px-0 mx-0 mb-3'>
                      <div class="col-12 p-0 mx-0">
                          <h5 class='montserrat verde'>E-mail</h5>
                          <input id='email' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                      </div>
                </div>    

                <div class='col col-12 row px-0 mx-0'>
                    <div class="col-6 p-0 mx-0">
                        <h5 class='montserrat verde'>Senha</h5>
                        <input id='senha' type='password' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                    </div>

                    <div class="col-6 py-0 pr-0 pl-3 mx-0">
                        <h5 class='montserrat verde'>Confirmar Senha</h5>
                        <input id='senha_confirmar' type='password' class='w-100 no-outline busca border-redonda tamanho-filtro px-2'></input>
                    </div>             
                </div>            
            </div>

            <div class="my-4">
                <div class='col col-12 row px-2 mx-0'>
                    <div class="px-0 row col col-12 mx-0">
                        <div id='msg' class='mx-0 px-0 vermelha montserrat col-9'></div>

                        <div class="col-3 px-0 mx-0">
                            <button class="btn-verde pull-right" onClick={teste_submit}>
                                <i class="fa fa-check mr-4 montserrat"></i>Criar Cadastro
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    )
}  

export default FormCriarUsuario;
